import React from 'react';
import getResourceLink from '../../../services/mini/getResourceLink';
import cancelEvent from '../../../services/mini/cancelEvent';
import LoaderWithCircle from '../LoaderWithCircle/LoaderWithCircle';

const AUDIO_EL_ID = 'intent-audio-el';
class PlayIntentAudioButton extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            loading: false,
            playing: false
        };
    }

    componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.props.stopAudioOnUnmount) {
            this.sendStopAudioEvent();
        }
    }

    sendStopAudioEvent() {
        window.dispatchEvent(new CustomEvent('stopAudio'));
    }

    toggleAudio = (e) => {
        const { intentAudioLink } = this.props;
        const { playing, loading } = this.state;

        if (playing || loading) {
            this.sendStopAudioEvent();
        } else {
            this.sendStopAudioEvent();
            this.createAudioEl();
            const audioEl = document.getElementById(AUDIO_EL_ID);
            window.addEventListener('stopAudio', this.onEnded, false);
            if (audioEl) {
                audioEl.currentTime = 0;
                audioEl.src = getResourceLink(intentAudioLink);
            }
        }
        cancelEvent(e);
    }

    createAudioEl() {
        // we use non-react way of the interacting with DOM,
        // because of the perf problems
        let audioEl = document.getElementById(AUDIO_EL_ID);

        if (!audioEl) {
            audioEl = document.createElement('audio');
            audioEl.style.display = 'none';
            audioEl.setAttribute('id', AUDIO_EL_ID);
            audioEl.setAttribute('autoplay', true);
            document.body.appendChild(audioEl);
        }

        audioEl.removeEventListener('loadstart', this.onLoadStart, false);
        audioEl.removeEventListener('playing', this.onPlaying, false);
        audioEl.removeEventListener('ended', this.onEnded, false);
        audioEl.removeEventListener('pause', this.onEnded, false);

        audioEl.addEventListener('loadstart', this.onLoadStart, false);
        audioEl.addEventListener('playing', this.onPlaying, false);
        audioEl.addEventListener('ended', this.onEnded, false);
        audioEl.addEventListener('pause', this.onEnded, false);

    }

    onLoadStart = () => {
        if (!this._isMounted) return;
        this.setState({ loading: true, playing: true });
    }

    onPlaying = () => {
        if (!this._isMounted) return;
        this.setState({ loading: false });
    }

    onEnded = () => {
        if (!this._isMounted) return;

        const audioEl = document.getElementById(AUDIO_EL_ID);

        if (audioEl) {
            audioEl.pause();
        }
        this.setState({ playing: false, loading: false });
        window.removeEventListener('stopAudio', this.onEnded, false);
        audioEl.removeEventListener('loadstart', this.onLoadStart, false);
        audioEl.removeEventListener('playing', this.onPlaying, false);
        audioEl.removeEventListener('ended', this.onEnded, false);
        audioEl.removeEventListener('pause', this.onEnded, false);
    }

    render() {
        const { loading, playing } = this.state;
        const { mode, intentAudioLink } = this.props;

        let btnState = 'default';

        if (loading) {
            btnState = 'loading';
        }
        if (playing) {
            btnState = 'playing';
        }

        if (!intentAudioLink) return <React.Fragment />;

        return <div className={`play-intent-audio-button ${mode} ${btnState}`}>
            <LoaderWithCircle className={loading && 'visible-with-opacity'} />
            <div
                title="Play audio intent"
                className={`play-intent-audio-button__icon ${playing ? 'playing' : 'default'}`}
                onClick={this.toggleAudio} />
            <audio
                ref={this.audioEl}
                autoPlay
                onLoadStart={this.onLoadStart}
                onPlaying={this.onPlaying}
                onEnded={this.onEnded}
                onPause={this.onEnded}
            />
        </div>;
    }
}

export default PlayIntentAudioButton;